import React from 'react'
import ErrorBoundaryAtom from '../@atoms/to_forms/error_boundary/error_boundary.atom'
import ContainerAtom from '../@atoms/to_layout/container/container.atom'
import RoutesHere from '../@f_routeshere'
import HeaderTemplate from '../@d_templates_opt/header/header.template'
import FooterTemplate from '../@d_templates_opt/footer/footer.template'
import ContentAreaTemplate from '../@d_templates_opt/content_area/content_area.template'
import GlobalStylesAtom from '../@atoms/to_layout/global_styles/global_styles.atom'
import CustomThemeProvider from '../@themes'
import localesList from '../locales/localesList'
import CrntLocaleAtom from '../@atoms/to_layout/crnt_locale/crnt_locale.atom'

const Layout: React.FC = function () {
  return (
    <CustomThemeProvider>
      <GlobalStylesAtom />
      <ErrorBoundaryAtom>
        <ContainerAtom ap_type="app_layout">
          <CrntLocaleAtom locales={localesList} />
          {/* Application Header */}
          <HeaderTemplate />
          {/* Application Content Area */}
          <ContentAreaTemplate>
            <RoutesHere />
          </ContentAreaTemplate>
          {/* Application Footer */}
          <FooterTemplate />
        </ContainerAtom>
      </ErrorBoundaryAtom>
    </CustomThemeProvider>
  )
}

export default Layout
